import { WorkerAction, WorkerActionError, WorkerFnParams } from '../wasm-git.worker.model';
import type { GitAction } from './actions.enum';

export interface GitRevParseAction extends WorkerAction {
  type: GitAction.RevParse;
  params: { rev: string };
}

export class GitRevParseActionError extends WorkerActionError {}

export async function GitRevParseActionFn({ lg, params }: WorkerFnParams<GitRevParseAction>): Promise<string> {
  const { rev } = params;

  try {
    const sha1 = lg.callAndCaptureOutput(['rev-parse', rev]);
    return sha1;
  } catch (err) {
    throw new GitRevParseActionError(err);
  }
}
